import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate, blueimpGalleryDestroy, removeReCaptchaBadge } from './shared/common'
// controllers
import Controller from './controllers/Controller'
import OwlCarouselController from './controllers/OwlCarouselController'
import TaxonomyController from './controllers/TaxonomyController'
import WatchembedController from './controllers/WatchembedController'
// views
import View from './views/View'
import BasicView from './views/BasicView'
import ListView from './views/ListView'
import MaskedView from './views/MaskedView'
import FullImageView from './views/FullImageView'
import OwlCarouselView from './views/OwlCarouselView'

const routes = {
  'basic': {
    controller: Controller,
    view: BasicView
  },
  'list': {
    controller: Controller,
    view: ListView
  },
  'masked': {
    controller: Controller,
    view: MaskedView
  },
  'full_image': {
    controller: Controller,
    view: FullImageView
  },
  'owl': {
    controller: OwlCarouselController,
    view: OwlCarouselView
  },
  'taxon_dropdown': {
    controller: TaxonomyController,
    view: null
  },
  'watchembed': {
    controller: WatchembedController,
    view: null
  },
}

const aswapProps = {
  animationTimeHide: 600,
  animationTimeShow: 800,
  preloadOnHover: false,
  cacheOn: true,
  refreshOnSameUrl: true,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    windowUpdate()
    blueimpGalleryDestroy()
    WCAG.onViewChanged()
    RytmWebflow.showUp.rebuild()
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    RytmWebflow.showUp.hide()
  }
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}